import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import SpeechModelSearch from "./SpeechModelSearch";
import SpeechModelTable from "./SpeechModelTable";
import '../modal.scss';
import SpeechModelCreate from "./SpeechModelCreate";
import {Slide, toast} from "react-toastify";

function SpeechModels({loggedInUser}) {
    const [models, setModels] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingModel, setEditingModel] = useState(null);

    const fetchModels = async (params) => {
        const baseUrl = `/speechModels`;
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setModels(response.data.list);
        } catch (error) {
            console.error('Error fetching models:', error);
        }
    };

    useEffect(() => {
        fetchModels();
    }, []);

    const search = async (name) => {
        const newSearchParams = {name};
        await fetchModels(newSearchParams);
    };

    const handleCreate = () => {
        setEditingModel(null);
        setShowModal(true);
    };

    const handleEdit = (model) => {
        setEditingModel(model);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/speechModels/${id}`;

        try {
            await apiClient.delete(url);
            await fetchModels();
        } catch (error) {
            console.error('Error deleting model:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (modelData) => {
        const url = editingModel ?
            `/speechModels/${editingModel.id}` :
            `/speechModels`;

        try {
            if (editingModel) {
                await apiClient.patch(url, modelData);
                toast.success('Speech Model updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, modelData);
                toast.success('Speech Model created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchModels();
        } catch (error) {
            console.error('Error saving model:', error);
        }
    };

    return (
        <div className="mainBody">
            <SpeechModelSearch onSearch={search} onCreate={handleCreate}/>
            <SpeechModelTable models={models} onEdit={handleEdit} onDelete={handleDelete}/>
            {showModal &&
                <SpeechModelCreate model={editingModel} onClose={handleCloseModal} onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default SpeechModels;
